import React from 'react';
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// import Breadcrumb from "../../Breadcrumb/Main";
// import Header from "../../headerone/Main";
import { Container, Row, Col } from 'react-bootstrap'; // Import Container, Row, and Col from the correct source
import { Link } from 'react-router-dom';



function Committees() {
    return (
        <>
            <section className="project-detail">
                <Container>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h3>Committees</h3>
                            </div>
                        </div>
                    </div>
                  
                 
                        
                       
                        <Row>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/internalcomplaintcommittee" className="c-link">Internal Complaints Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/internalcomplaintcommittee" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/anti-ragging" className="c-link">Anti-Ragging Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/anti-ragging" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/liaison-officers" className="c-link">SC/ST/OBC Liaison Officers/Cell</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/liaison-officers" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                     
                                <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/differently_abled_support_service_cell" className="c-link">Differently Abled Support Service Cell</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/differently_abled_support_service_cell" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                               
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/Timetable_Committee" className="c-link">Timetable Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/liaison-officers" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                     
                                
                               
                        </Row>
               
                        
                    
                </Container> {/* container */}
            </section>
        </>
    )
}

export default Committees;
